import React from "react";

interface PieChartProps {
  data: { label: string; value: number; color: string }[];
  size?: number;
}
export default function PieChart({ data, size = 190 }: PieChartProps) {
  const total = data.reduce((sum, d) => sum + d.value, 0) || 1;
  let start = 0;
  function getArc(value: number) {
    const r = size/2 - 7;
    const cx = size/2, cy = size/2;
    const frac = value / total;
    const end = start + frac * 2 * Math.PI;
    const x1 = cx + r * Math.cos(start - Math.PI / 2);
    const y1 = cy + r * Math.sin(start - Math.PI / 2);
    const x2 = cx + r * Math.cos(end - Math.PI / 2);
    const y2 = cy + r * Math.sin(end - Math.PI / 2);
    const large = end - start > Math.PI ? 1 : 0;
    const path = `M${cx},${cy} L${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} Z`;
    start = end;
    return path;
  }
  return (
    <div className="flex flex-col items-center w-full py-3">
      <div className="flex justify-center w-full">
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          className="block"
        >
          {(() => { start = 0; return data.map((d, i) => (
            <path
              key={d.label}
              d={getArc(d.value)}
              fill={d.color}
              stroke="#fff"
              strokeWidth={3}
              opacity=".99"
            />
          )); })()}
        </svg>
      </div>
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 w-full mt-2">
        {data.map(d => (
          <div key={d.label} className="flex items-center gap-2 text-xs mb-1">
            <span className="inline-block w-3 h-3 rounded-full" style={{ background: d.color }} />
            <span className="font-semibold text-primary/90">{d.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}